import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useAuditByTarget = (projectId: string, targetID: string) => {
  const p = ENDPOINTS.AUDIT.byTarget(projectId, targetID)
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })
  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
